import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceindurapurindustrialarea() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Durgapur Industrial Area ',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Durgapur Industrial Area ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Durgapur Industrial Area, catering to the transportation needs of manufacturing units, industrial estates, logistics hubs, and corporate offices across the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, supervisors, and senior executives. Whether it is daily office commute, shift-based transport, industrial visits, airport transfers, inter-plant travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions with trained chauffeurs, GPS-enabled well-maintained vehicles, and flexible rental plans, ensuring a premium and dependable corporate travel experience for businesses operating in and around Durgapur Industrial Area.',

    top: 'Top Places to Visit in Durgapur with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Durgapur Barrage",
    "description": "Durgapur Barrage is one of the most prominent landmarks of the city, built across the Damodar River as part of the Damodar Valley irrigation system. The barrage not only regulates water flow for agriculture and industry but also serves as a scenic spot where visitors can enjoy peaceful river views, cool breezes, and sunsets. The surrounding areas often attract joggers, photographers, and families, making it a popular recreational place that blends engineering significance with natural beauty."
  },
  {
    "title": "Durgapur Steel Plant",
    "description": "Established in 1959, the Durgapur Steel Plant is one of India’s earliest integrated steel plants and a key part of the country’s industrial foundation. Operated by SAIL, the plant produces various steel products for national infrastructure and manufacturing sectors. While entry is restricted, the massive factory complex, worker townships, and industrial heritage reflect the rise of Durgapur as the ‘Steel City of Eastern India.’ The plant remains a symbol of progress, employment, and engineering development in the region."
  },
  {
    "title": "Troika Park",
    "description": "Troika Park is a well-maintained recreational park featuring landscaped lawns, walking paths, children’s play zones, lake views, and quiet seating areas. Families come here for evening walks, outdoor relaxation, picnics, and safe playtime for kids. Musical fountains and open spaces make the ambiance lively, particularly during weekends. The park offers a refreshing escape from urban bustle and is one of Durgapur’s most inviting outdoor spaces."
  },
  {
    "title": "Bhabani Pathak’s Tilla",
    "description": "Bhabani Pathak’s Tilla is a historical site connected to the legendary freedom-era character Sanyasi Bhabani Pathak, popularized in Bankim Chandra Chattopadhyay’s literary works. The underground tunnels, stone pathways, and old chambers give the place a mysterious aura. Visitors interested in heritage exploration often enjoy the site for its folklore, old structures, and green surroundings. It serves as a reminder of Bengal’s revolutionary past and cultural narratives."
  },
  {
    "title": "Kumaramangalam Park",
    "description": "Kumaramangalam Park is a favorite weekend destination featuring manicured gardens, boating facilities, sitting areas, and serene lakeside views. Families, couples, and children visit the park to relax, walk, play, and enjoy outdoor activities in a natural setting. The colorful lighting at night makes the park visually appealing, transforming it into a relaxing and photogenic hangout spot. Clean surroundings and peaceful ambiance make it ideal for evening outings."
  },
  {
    "title": "Rahreswar Shivalaya Temple",
    "description": "Rahreswar Shivalaya is one of the oldest and most revered temples in the region, believed to date back several centuries. Dedicated to Lord Shiva, the temple features classic Bengal-style architecture with terracotta detailing and a calm spiritual atmosphere. Devotees visit especially during Shivratri and other festivals, when religious rituals and cultural activities take place. The temple is not just a place of worship but also a symbol of the region’s spiritual legacy."
  },
  {
    "title": "Benachity Market",
    "description": "Benachity Market is the oldest and most vibrant commercial hub in Durgapur, famous for traditional Bengali wedding goods, household items, textiles, handicrafts, and daily-use products. The narrow lanes filled with shops offer the charm of a classic Indian bazaar, where bargaining, lively crowds, and local vendors create a bustling atmosphere. Visitors can shop for brassware, traditional ornaments, sarees, and local craft items while experiencing authentic everyday life in Durgapur."
  },
  {
    "title": "Junction Mall",
    "description": "Junction Mall is a modern lifestyle and entertainment center that has become one of Durgapur’s most popular hangout spots. The mall houses national and international retail outlets, a multiplex cinema, restaurants, and gaming zones. It is a preferred location for shopping, movie outings, casual dining, and weekend entertainment. The clean interiors and festive decorations during events make it a lively urban attraction for families, youth, and travelers."
  },
  {
    "title": "Nachan Dam",
    "description": "Nachan Dam is a scenic location near Durgapur known for its peaceful waterbody, lush greenery, and rural surroundings. It is a popular picnic and outdoor relaxation spot, especially during monsoon and winter when the landscape is at its most beautiful. Birdwatchers, couples, cyclists, and nature lovers often visit to enjoy quiet moments away from the city noise. The dam area provides a refreshing escape and a chance to experience the countryside charm of West Bengal."
  },
  {
    "title": "Gopalpur Eco Park",
    "description": "Gopalpur Eco Park is a nature-friendly recreational space offering walking trails, gardens, boating facilities, children’s areas, and shaded sitting spots. Designed to promote green living and sustainable leisure, the park attracts families, photographers, and fitness enthusiasts. Seasonal flowers, landscaped lawns, and clean pathways create a relaxing and scenic environment. It is one of the newer and more modern additions to Durgapur’s leisure landscape, ideal for peaceful evenings and weekend visits."
  }
],


"services": [
  {
    "name": "Durgapur Industrial Cab",
    "description": "Durgapur Industrial Cab provides dedicated corporate transportation for employees and executives commuting to industrial zones in Durgapur. Equipped with sedans, SUVs, and shuttles, it ensures safe, reliable, and timely transport with professional drivers and GPS-enabled tracking."
  },
  {
    "name": "Employee Shuttle Durgapur Industrial Area",
    "description": "Employee Shuttle Durgapur Industrial Area offers high-capacity, scheduled shuttle services for daily workforce commute. Features include route optimization, AC minibuses, shift-based pick-up/drop-off, and real-time tracking for efficient industrial area mobility."
  },
  {
    "name": "Corporate Transport Durgapur",
    "description": "Corporate Transport Durgapur provides end-to-end mobility solutions for businesses, including employee commute, executive travel, and visitor transportation. With managed fleets, trained drivers, and GPS monitoring, it ensures punctual and safe operations."
  },
  {
    "name": "Factory Worker Transport Durgapur",
    "description": "Factory Worker Transport Durgapur specializes in transporting large workforce teams to factories and industrial units. Services include structured pick-up/drop routes, multi-shift support, and secure, monitored travel for all employees."
  },
  {
    "name": "Business Cab Durgapur Industrial Area",
    "description": "Business Cab Durgapur Industrial Area delivers premium travel solutions for corporate meetings, client visits, airport transfers, and executive commutes. Vehicles include sedans and SUVs with professional chauffeurs for comfortable and punctual travel."
  },
  {
    "name": "Staff Pickup Drop Durgapur",
    "description": "Staff Pickup Drop Durgapur provides reliable and organized daily employee transport with predefined routes, shift-aligned schedules, GPS tracking, and trained drivers for a seamless commuting experience."
  },
  {
    "name": "Monthly Cab Durgapur Industrial Area",
    "description": "Monthly Cab Durgapur Industrial Area offers long-term corporate cab services with dedicated vehicles, professional drivers, route optimization, and real-time monitoring for uninterrupted monthly employee transportation."
  },
  {
    "name": "Affordable Cab Durgapur",
    "description": "Affordable Cab Durgapur provides budget-friendly corporate transportation solutions for SMEs and mid-sized companies without compromising on safety, punctuality, or comfort."
  },
  {
    "name": "Best Corporate Cab Durgapur",
    "description": "Best Corporate Cab Durgapur delivers premium-grade services with high-quality vehicles, experienced chauffeurs, and superior safety protocols, catering to executives, managers, and VIP staff."
  },
  {
    "name": "Outstation Cab Durgapur",
    "description": "Outstation Cab Durgapur offers long-distance corporate travel solutions for client visits, intercity meetings, and factory tours, featuring comfortable vehicles, trained drivers, GPS tracking, and interstate permits."
  },
  {
    "name": "Sedan Cab Durgapur",
    "description": "Sedan Cab Durgapur provides executive sedans for managerial commutes, airport runs, and business trips. Vehicles are maintained to premium standards and driven by professional chauffeurs."
  },
  {
    "name": "SUV Cab Durgapur",
    "description": "SUV Cab Durgapur delivers spacious and high-comfort SUVs for team travel, senior management commute, and outstation trips, ensuring safety, comfort, and punctuality."
  },
  {
    "name": "Employee Mobility Durgapur",
    "description": "Employee Mobility Durgapur offers flexible, tech-enabled commute solutions integrating real-time GPS tracking, optimized routes, and scheduling support for efficient workforce transportation."
  },
  {
    "name": "Corporate Fleet Durgapur",
    "description": "Corporate Fleet Durgapur provides fleet management services including vehicle maintenance, driver management, route planning, and scalable corporate transport solutions for companies in Durgapur."
  },
  {
    "name": "Industrial Shuttle Durgapur",
    "description": "Industrial Shuttle Durgapur provides structured shuttle services for industrial zones with AC minibuses, optimized routes, automated attendance integration, and safety protocols for bulk staff movement."
  }
],

"tableData": [
  ["Durgapur Industrial Cab", "Employee Shuttle Durgapur Industrial Area"],
  ["Corporate Transport Durgapur", "Factory Worker Transport Durgapur"],
  ["Business Cab Durgapur Industrial Area", "Staff Pickup Drop Durgapur"],
  ["Monthly Cab Durgapur Industrial Area", "Affordable Cab Durgapur"],
  ["Best Corporate Cab Durgapur", "Outstation Cab Durgapur"],
  ["Sedan Cab Durgapur", "SUV Cab Durgapur"],
  ["Employee Mobility Durgapur", "Corporate Fleet Durgapur"],
  ["Industrial Shuttle Durgapur", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Durgapur Industrial Area",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Durgapur Industrial Area, ensuring smooth and efficient transportation for employees and business executives across the industrial zone."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We provide punctual pickups and drop-offs across Durgapur Industrial Area, helping employees reach factories, offices, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure safe, courteous, and disciplined travel, offering a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Durgapur Industrial Area."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored cab rental plans to meet the commuting requirements of companies and employees in Durgapur Industrial Area."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team offers round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, providing secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking system and reliable coordination, making employee transport hassle-free."
  }
]














  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Durgapur Industrial Area?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and industrial offices in Durgapur Industrial Area.',
  },
  {
    question: 'What types of corporate transportation services are available in Durgapur Industrial Area?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and complete fleet management for corporate and industrial clients.',
  },
  {
    question: 'Do you support daily employee commute services in Durgapur Industrial Area?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Durgapur Industrial Area?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Durgapur Industrial Area?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Durgapur Industrial Area?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Durgapur Industrial Area?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anupam Roy',
    feedback: 'Very reliable corporate cab service for our Durgapur Industrial Area office. Drivers are punctual and vehicles are well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rina Sen',
    feedback: 'Professional and efficient service. Our employees appreciate the smooth and timely commute every day.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Durgapur Industrial Area",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-durgapur.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Durgapur Industrial Area, including industrial cabs, employee shuttle, corporate transport, factory worker transport, business cabs, staff pickup & drop, monthly corporate cab rentals, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, employee mobility solutions, and complete corporate fleet management.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-durgapur-industrial-area"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Durgapur Industrial Area | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Durgapur Industrial Area including industrial cabs, employee shuttle, corporate transport, factory worker transport, business cabs, staff pickup & drop, monthly corporate cab rentals, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, employee mobility solutions, and corporate fleet management."
  />

  <meta
    name="keywords"
    content="Durgapur Industrial Cab, Employee Shuttle Durgapur Industrial Area, Corporate Transport Durgapur, Factory Worker Transport Durgapur, Business Cab Durgapur Industrial Area, Staff Pickup Drop Durgapur, Monthly Cab Durgapur Industrial Area, Affordable Cab Durgapur, Best Corporate Cab Durgapur, Outstation Cab Durgapur, Sedan Cab Durgapur, SUV Cab Durgapur, Employee Mobility Durgapur, Corporate Fleet Durgapur, Industrial Shuttle Durgapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceindurapurindustrialarea;